import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { AppProfiler } from '#features/app/components/shared/AppProfiler.tsx';
import { SecuredApplication } from '#features/app/components/shared/SecuredApplication';
import { routerWeb } from '#features/app/routerWeb.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProfiler id="Web.main">
      <SecuredApplication>
        <AppProfiler id="Web.main.routerWeb">
          <RouterProvider router={routerWeb} />
        </AppProfiler>
      </SecuredApplication>
    </AppProfiler>
  </StrictMode>,
);
